(function($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    jQuery(document).ready(function($) {
        // Current packages
        var puffSlide1 = new Swiper('.posts-slider', {
            grabCursor: true,
            slidesPerView: 'auto',
            slidesOffsetBefore: 0,
            keyboard: {
                enabled: true
            },
            breakpoints: {
                320: {
                  slidesOffsetBefore: 25,
                },
                1199: {
                  slidesOffsetBefore: 0,
                },
            }
        });

    });
})(jQuery);

//# sourceMappingURL=swiper-controls.js.map
